import { getQuickReplies, quickReplyStore } from '../../features/quick-replies/models/quickReplyStore';
import { useEffect, useState, useSyncExternalStore } from "react";
import { fetchActionBindings, fetchCanonicalChannelAccounts } from "./canonicalMessagingApi";

export const ACTION_UNBOUND_MESSAGE = "Your admin hasn't set the default message for this action";

export async function resolveActionSnippet(action) {
  const channels = await fetchCanonicalChannelAccounts();
  const channel = channels.find(item => item.audience === "customer");
  if (!channel?.id) throw new Error("Customer messaging channel is unavailable.");
  const bindings = await fetchActionBindings(channel.id, action);
  const binding = bindings.find(item => item.action === action);
  if (!binding?.snippet_id) throw new Error(ACTION_UNBOUND_MESSAGE);
  const snippets = await getQuickReplies(channel.id);
  const snippet = snippets.find(item => item.id === binding.snippet_id);
  if (!snippet) throw new Error(ACTION_UNBOUND_MESSAGE);
  return snippet;
}

export function useActionSnippet(open, action) {
  const [state, setState] = useState({ snippet: null, loading: true, error: "" });
  const key = `${open}:${action}`;
  useEffect(() => {
    let active = true;
    setState({ key, snippet: null, loading: Boolean(open), error: "" });
    if (open) resolveActionSnippet(action).then(snippet => {
      if (active) setState({ key, snippet, loading: false, error: "" });
    }).catch(error => {
      if (active) setState({ key, snippet: null, loading: false, error: error.code === "MESSAGING_ACTION_UNBOUND" ? ACTION_UNBOUND_MESSAGE : error.message });
    });
    return () => { active = false; };
  }, [open, action, key]);
  const live = useSyncExternalStore(quickReplyStore.subscribe, () => state.snippet ? quickReplyStore.find(state.snippet.id) : null);
  return state.key === key ? { ...state, snippet: live || state.snippet } : { snippet: null, loading: Boolean(open), error: "" };
}
